export const useCaseLinks = [
  { href: "/chatgpt-to-pdf", label: "ChatGPT to PDF" },
  { href: "/gemini-to-pdf", label: "Gemini to PDF" },
  { href: "/resume-to-pdf", label: "Resume to PDF" },
  { href: "/mermaid-to-pdf", label: "Mermaid to PDF" },
  { href: "/readme-to-pdf", label: "README to PDF" },
] as const;

export const useCaseLinksPrimary = [
  useCaseLinks[0],
  useCaseLinks[1],
  useCaseLinks[2],
] as const;

export const useCaseLinksSecondary = [
  useCaseLinks[3],
  useCaseLinks[4],
] as const;
